import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export const DismissButton = ({ onClick }: { onClick: (e: any) => void }) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: 'absolute',
      top: 3,
      right: 3
    }}
    size="small"
  >
    <CloseIcon fontSize="small" />
  </IconButton>
);
